import { createTheme } from '@mui/material/styles'

// export const primaryColour = '#dd944b'
// export const primaryDarkColour = '#c27325'
// export const secondaryColour = '#dd4b4b'
// export const secondaryDarkColour = '#ad2121'

export const secondaryColour = '#dd944b'
export const secondaryDarkColour = '#c27325'
export const primaryColour = '#dd4b4b'
export const primaryDarkColour = '#ad2121'

const getTheme = (mode = 'light') =>
  createTheme({
    palette: {
      mode,
      primary: {
        main: primaryColour,
        dark: primaryDarkColour
      },
      secondary: {
        main: secondaryColour,
        dark: secondaryDarkColour
      },
      error: {
        main: '#f1360e'
      },
      background: {
        default: mode === 'dark' ? '#121212' : '#fafafa',
        paper: mode === 'dark' ? '#1d1d1d' : '#ffffff'
      },
      divider: mode === 'dark' ? 'rgba(255,255,255,0.12)' : '#e0e0e0'
    },
    typography: {
      h1: {
        fontSize: '2rem',
        color: secondaryColour
      }
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: mode === 'dark' ? '#121212' : '#fafafa'
          }
        }
      }
    }
  })

export default getTheme
